export default __webpack_public_path__ + "static/media/sexual-assault-service-icon.3da82c58.svg";